//todo just added temporary flash need to work on it - I need to understand type of error from API's to design and build this component
//After implementing add unit tests for this and remove from test coverage exclude list in vite.config.ts file
import React, { useId, useState } from "react";
import CloudScapeFlashbar, {
  FlashbarProps,
} from "@cloudscape-design/components/flashbar";
import { useDisclaimerFlashbarItem } from "./disclaimer-flashbar-item";

function useNotifications(showSuccessNotification = false) {
  const successId = useId();
  const [successDismissed, dismissSuccess] = useState(false);
  const [disclaimerDismissed, dismissDisclaimer] = useState(false);

  const disclaimerItem = useDisclaimerFlashbarItem(() =>
    dismissDisclaimer(true)
  );

  const notifications: Array<FlashbarProps.MessageDefinition> = [];

  if (disclaimerItem && !disclaimerDismissed) {
    notifications.push(disclaimerItem);
  }

  if (showSuccessNotification && !successDismissed) {
    notifications.push({
      type: "success",
      content: "Resource created successfully",
      statusIconAriaLabel: "success",
      dismissLabel: "Dismiss message",
      dismissible: true,
      onDismiss: () => dismissSuccess(true),
      id: successId,
    });
  }

  return notifications;
}

interface NotificationsProps {
  successNotification?: boolean;
}

export function Notifications({ successNotification }: NotificationsProps) {
  const notifications = useNotifications(successNotification);
  return <CloudScapeFlashbar items={notifications} />;
}
